<template>
  <div class="modal fade" id="modalFormDar" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-dar" style="max-width: 780px;">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <div>
            <h4 class="modal-title" style="font-weight: bold;">Buat Dokumen DAR (Damage Analysis Report)</h4>
            <div class="modal-subtitle">Simpan sebagai draft atau submit setelah formulir selesai.</div>
          </div>
          <button type="button" class="close" data-dismiss="modal" @click="resetForm">&times;</button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body px-4 py-3">

          <!-- Informasi Tiket -->
          <div class="section-card mb-3">
            <div class="section-title mb-3">Informasi Tiket</div>
            <div class="row">
              <div class="col-md-4 mb-3 mb-md-0">
                <label class="field-label">No Tiket</label>
                <input type="text" class="form-control readonly-field" :value="displayTicketNumber" disabled>
              </div>
              <div class="col-md-4 mb-3 mb-md-0">
                <label class="field-label">Tanggal Dibuat</label>
                <input type="text" class="form-control readonly-field" :value="displayTanggalDibuat" disabled>
              </div>
              <div class="col-md-4">
                <label class="field-label">Dibuat Oleh</label>
                <input type="text" class="form-control readonly-field" :value="displayCreatedBy" disabled>
              </div>
            </div>
          </div>

          <!-- Informasi Produk -->
          <div class="section-card mb-3">
            <div class="section-title mb-3">Informasi Produk</div>
            <div class="row mb-3">
              <div class="col-md-6 mb-3 mb-md-0">
                <label class="field-label">No. Order</label>
                <input type="text" class="form-control readonly-field" :value="displayOrderId" disabled>
              </div>
              <div class="col-md-6">
                <label class="field-label">Tipe Produk</label>
                <input type="text" class="form-control readonly-field" :value="displayProductType" disabled>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6 mb-3 mb-md-0">
                <label class="field-label">Kode Produk</label>
                <input type="text" class="form-control readonly-field" :value="displayProductCode" disabled>
              </div>
              <div class="col-md-6">
                <label class="field-label">No. Serial</label>
                <input type="text" class="form-control readonly-field" :value="displaySerialNumber" disabled>
              </div>
            </div>
            <div class="mb-3">
              <label class="field-label">Spesifikasi</label>
              <textarea class="form-control readonly-field specification-field" :value="displaySpecification" disabled rows="3"></textarea>
              <!-- <div class="readonly-field bom-items-box"> -->
                <!-- <template v-if="bomItemsList.length">
                  <div v-for="(item, index) in bomItemsList" :key="`bom-${index}`">
                    {{ item.group }} : {{ item.name }} (Qty : {{ item.qty }})
                  </div>
                </template> -->
                <!-- <template v-else>-</template> -->
              <!-- </div> -->
            </div>
            <!-- <div>
              <label class="field-label">Serial Number (SN)</label>
              <input type="text" class="form-control readonly-field" :value="displaySerialNumber" disabled>
            </div> -->
          </div>

          <!-- Foto Produk -->
          <div class="section-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="section-title mb-0">Foto Produk</div>
              <div class="photo-counter">{{ photoCount }}/5 foto</div>
            </div>
            <div class="photo-upload-row">
              <div
                class="photo-slot"
                :class="{ 'has-image': !!photo.imgUrl }"
                v-for="(photo, index) in photos"
                :key="`photo-${index}`"
                @click="triggerPhotoInput(index)"
              >
                <img v-if="photo.imgUrl" :src="photo.imgUrl" class="photo-preview" alt="Foto produk">
                <div v-else class="photo-slot-placeholder">
                  <i class="fas fa-camera"></i>
                  <div class="photo-slot-label">Foto {{ index + 1 }}</div>
                </div>
                <button
                  type="button"
                  class="photo-remove"
                  v-if="photo.imgUrl"
                  @click.stop="removePhoto(index)"
                >&times;</button>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  :ref="`photoInput${index}`"
                  hidden
                  @change="handlePhotoChange($event, index)"
                >
              </div>
            </div>
            <div class="field-hint mt-2">Format JPG/PNG, maksimal 5 foto.</div>
          </div>

          <!-- Identifikasi Masalah & Pemeriksaan Awal -->
          <div class="section-card mb-3">
            <div class="section-title mb-3">Identifikasi Masalah & Pemeriksaan Awal</div>
            <div class="mb-3">
              <label class="field-label">Temuan Teknisi</label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': findingsInvalid }"
                rows="3"
                v-model="technicianFindings"
                placeholder="Contoh: Laptop terkena air, muncul bercak air dan korosi pada komponen internal..."
              ></textarea>
            </div>
            <div class="row mb-3">
              <div class="col-md-6 mb-3 mb-md-0">
                <label class="field-label">Komponen Rusak</label>
                <textarea
                  class="form-control"
                  :class="{ 'is-invalid': damagedComponentsInvalid }"
                  rows="3"
                  v-model="damagedComponents"
                  placeholder="Contoh: Mainboard (Korosi), Keyboard (Korosi), Flexible (Korosi)"
                ></textarea>
              </div>
              <div class="col-md-6">
                <label class="field-label">Komponen Lainnya</label>
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="otherComponents"
                  placeholder="Contoh: Berfungsi normal (lecet pemakaian wajar)"
                ></textarea>
              </div>
            </div>
            <div>
              <label class="field-label d-block">Kategori Kerusakan</label>
              <div
                class="d-flex flex-wrap"
                :class="{ 'is-invalid-box': damageCategoryInvalid }"
                style="gap: 24px;"
              >
                <label class="radio-inline" v-for="opt in damageCategoryOptions" :key="opt.value">
                  <input type="radio" v-model="damageCategory" :value="opt.value"> {{ opt.label }}
                </label>
              </div>
            </div>
          </div>

          <!-- Solusi yang Disarankan -->
          <div class="section-card mb-3">
            <div class="section-title mb-3">Solusi yang Disarankan</div>

            <div class="part-card mb-3" v-for="(part, index) in parts" :key="`part-${index}`">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="part-title">Part {{ index + 1 }}</div>
                <button type="button" class="btn-remove-part" v-if="parts.length > 1" @click="removePart(index)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
              <div class="mb-3">
                <label class="field-label">Nama Part</label>
                <div :class="{ 'multiselect-invalid': isPartInvalid(index) }">
                  <multiselect
                    v-model="part.selectedPart"
                    :ref="`partSelect${index}`"
                    :options="part.options"
                    label="itemName"
                    track-by="itemCode"
                    placeholder="Pilih part"
                    :allow-empty="true"
                    :select-label="''"
                    :deselect-label="''"
                    :internal-search="false"
                    :loading="part.searching"
                    @search-change="query => onPartSearch(query, index)"
                    @open="onPartDropdownOpen(index)"
                  >
                    <template slot="noResult" slot-scope="{ search }">
                      <div class="part-not-found-text">Part &ldquo;{{ search }}&rdquo; tidak ditemukan.</div>
                      <button
                        type="button"
                        class="btn-add-custom-part"
                        @mousedown.prevent
                        @click="onAddCustomPart(search, index)"
                      >
                        <i class="fas fa-plus mr-1"></i> Tambah &ldquo;{{ search }}&rdquo; ke daftar nama part
                      </button>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3 mb-md-0">
                  <label class="field-label d-block">Siapa yang menanggung biaya?</label>
                  <div class="d-flex" style="gap: 24px;">
                    <label class="radio-inline">
                      <input type="radio" v-model="part.coveredBy" value="asani"> Asani
                    </label>
                    <label class="radio-inline">
                      <input type="radio" v-model="part.coveredBy" value="client"> Client
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="field-label">Perkiraan Harga (Rp)</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Rp</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      :value="part.perkiraanHargaDisplay"
                      @input="onHargaInput(index, $event)"
                      placeholder="0"
                      :disabled="part.coveredBy === 'asani'"
                    >
                  </div>
                  <div class="field-hint" v-if="part.coveredBy === 'client'">Biaya part ini akan ditagihkan ke client.</div>
                  <div class="field-hint" v-else-if="part.coveredBy === 'asani'">Biaya part ini ditanggung Asani.</div>
                </div>
              </div>
            </div>

            <button type="button" class="btn btn-outline-primary btn-block mb-3" @click="addPart" v-if="parts.length < maxParts">
              <i class="fas fa-plus mr-1"></i> Tambah Part
            </button>
            <div class="field-hint mb-3" v-else>Maksimal {{ maxParts }} part.</div>

            <div class="total-box mb-2">
              <div class="d-flex justify-content-between">
                <span>Total Ditanggung Asani (internal)</span>
                <span>Rp {{ formatRupiah(totalAsani) }}</span>
              </div>
              <div class="field-hint">Nominal diatas hanya untuk keperluan internal dan tidak akan dicantumkan pada dokumen yang diserahkan ke client.</div>
            </div>
            <div class="total-box total-box-highlight mb-3">
              <div class="d-flex justify-content-between">
                <span>Total Perkiraan Biaya (Ditanggung Client)</span>
                <span class="text-primary font-weight-bold">Rp {{ formatRupiah(totalClient) }}</span>
              </div>
            </div>

            <div>
              <label class="field-label">Catatan</label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': notesInvalid }"
                rows="2"
                v-model="notes"
                placeholder="Contoh: Harga dapat berubah sewaktu-waktu sesuai ketersediaan di pasaran."
              ></textarea>
            </div>
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer justify-content-end">
          <button type="button" class="btn btn-outline-secondary" @click="saveDraft" :disabled="loadingDraft" v-if="canSaveDraft && (allowCreateDarDoc || allowEditDarDoc)">
            Simpan Draft
            <img src="@/assets/images/2.gif" style="height: 18px; margin-left: 4px;" v-if="loadingDraft">
          </button>
          <button type="button" class="btn btn-primary" @click="submitDocument" :disabled="loadingSubmit" v-if="allowCreateDarDoc || allowEditDarDoc">
            Submit Dokumen
            <img src="@/assets/images/2.gif" style="height: 18px; margin-left: 4px;" v-if="loadingSubmit">
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'

export default {
  name: 'ModalFormDar',
  components: { Multiselect },
  props: {
    ticketId: { type: [Number, String], default: null },
    ticketNumber: { type: String, default: '' },
    technicianName: { type: String, default: '' },
    orderId: { type: String, default: '' },
    productCode: { type: String, default: '' },
    productTypeName: { type: String, default: '' },
    productModel: { type: String, default: '' },
    productSN: { type: String, default: '' },
    bomItems: { type: Array, default: () => [] },
    darDetail: { type: Object, default: null },
  },
  data() {
    return {
      allowViewDarDoc: false,
      allowEditDarDoc: false,
      allowCreateDarDoc: false,
      fetchedTicket: null,
      fetchedProduct: null,
      resolvedCreatedBy: '',
      tanggalDibuat: this.getToday(),
      photos: this.emptyPhotos(),
      technicianFindings: '',
      damagedComponents: '',
      otherComponents: '',
      damageCategory: '',
      damageCategoryOptions: [
        { value: 'ringan', label: 'Ringan' },
        { value: 'sedang', label: 'Sedang' },
        { value: 'berat', label: 'Berat' },
      ],
      parts: [this.emptyPart()],
      maxParts: 10,
      notes: 'Harga dapat berubah sewaktu-waktu sesuai ketersediaan di pasaran.',
      partSearchTimers: {},
      errorMessage: '',
      loadingDraft: false,
      loadingSubmit: false,
      attemptedSave: false,
      attemptedSubmit: false,
    }
  },
  computed: {
    displayTicketNumber() {
      return (this.fetchedTicket && this.fetchedTicket.ticketNo) || this.ticketNumber
    },
    displayTanggalDibuat() {
      if (!this.tanggalDibuat) return ''
      const [year, month, day] = this.tanggalDibuat.split('-')
      return `${day}-${month}-${year}`
    },
    displayCreatedBy() {
      return this.resolvedCreatedBy || 'PIC IT Support'
    },
    displayOrderId() {
      return (this.fetchedProduct && this.fetchedProduct.orderId) || this.orderId
    },
    displayProductCode() {
      return (this.fetchedProduct && this.fetchedProduct.productCode) || this.productCode
    },
    displayProductType() {
      return (this.fetchedProduct && this.fetchedProduct.productType) || this.productTypeName
    },
    displaySerialNumber() {
      return (this.fetchedProduct && this.fetchedProduct.serialNumber) || this.productSN
    },
    displaySpecification() {
      return (this.fetchedProduct && this.fetchedProduct.specification) || '-'
    },
    // bomItemsList() {
    //   const items = (this.fetchedProduct && this.fetchedProduct.bomItems) || this.bomItems || []
    //   return items.map(item => ({
    //     group: item.component !== undefined ? item.component : item.itemGroup,
    //     name: item.name !== undefined ? item.name : item.itemName,
    //     qty: item.qty !== undefined ? item.qty : item.itemQty,
    //   }))
    // },
    photoCount() {
      return this.photos.filter(p => p.imgUrl).length
    },
    totalAsani() {
      return this.parts
        .filter(p => p.coveredBy === 'asani')
        .reduce((sum, p) => sum + (parseInt(p.perkiraanHarga, 10) || 0), 0)
    },
    totalClient() {
      return this.parts
        .filter(p => p.coveredBy === 'client')
        .reduce((sum, p) => sum + (parseInt(p.perkiraanHarga, 10) || 0), 0)
    },
    canSubmit() {
      if (!this.technicianFindings.trim()) return false
      if (!this.damagedComponents.trim()) return false
      if (!this.damageCategory) return false
      if (!this.parts.length || this.parts.some(p => !p.selectedPart)) return false
      if (!this.notes.trim()) return false
      return true
    },
    canSaveDraft() {
      return !this.darDetail || !this.darDetail.createdAt || this.darDetail.asDraft !== 0
    },
    findingsInvalid() {
      return this.attemptedSubmit && !this.technicianFindings.trim()
    },
    damagedComponentsInvalid() {
      return this.attemptedSubmit && !this.damagedComponents.trim()
    },
    damageCategoryInvalid() {
      return this.attemptedSubmit && !this.damageCategory
    },
    notesInvalid() {
      return this.attemptedSubmit && this.notes.trim().length < 50
    },
  },
  methods: {
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '7.5') {
          this.allowViewDarDoc = true
        }
        if (this.permission[i] == '7.6') {
          this.allowEditDarDoc = true
        }
        if (this.permission[i] == '7.7') {
          this.allowCreateDarDoc = true
        }
      }
    },
    isPartInvalid(index) {
      return this.attemptedSave && !this.parts[index].selectedPart
    },
    getToday() {
      const d = new Date()
      const pad = n => n.toString().padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
    emptyPhotos() {
      return Array.from({ length: 5 }, () => ({ imgFileName: '', imgBase64: '', imgUrl: '', isExisting: false }))
    },
    emptyPart() {
      return { selectedPart: null, coveredBy: 'client', perkiraanHarga: '', perkiraanHargaDisplay: '', options: [], searching: false }
    },
    triggerPhotoInput(index) {
      const refName = `photoInput${index}`
      if (this.$refs[refName] && this.$refs[refName][0]) {
        this.$refs[refName][0].click()
      }
    },
    handlePhotoChange(event, index) {
      const file = event.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.$set(this.photos, index, {
          imgFileName: file.name,
          imgBase64: reader.result.split(',')[1],
          imgUrl: reader.result,
          isExisting: false,
        })
      }
    },
    removePhoto(index) {
      this.$set(this.photos, index, { imgFileName: '', imgBase64: '', imgUrl: '', isExisting: false })
      const refName = `photoInput${index}`
      if (this.$refs[refName] && this.$refs[refName][0]) {
        this.$refs[refName][0].value = null
      }
    },
    addPart() {
      if (this.parts.length >= this.maxParts) return
      this.parts.push(this.emptyPart())
      this.fetchPartOptions('', this.parts.length - 1)
    },
    removePart(index) {
      this.parts.splice(index, 1)
    },
    onHargaInput(index, event) {
      const numeric = event.target.value.replace(/[^\d]/g, '')
      this.parts[index].perkiraanHarga = numeric
      this.parts[index].perkiraanHargaDisplay = this.formatRupiah(numeric || '0')
    },
    formatRupiah(angka) {
      const numberString = angka.toString().replace(/[^,\d]/g, '')
      const split = numberString.split(',')
      const sisa = split[0].length % 3
      const rupiah = split[0].substr(0, sisa)
      const ribuan = split[0].substr(sisa).match(/\d{3}/gi)
      if (ribuan) {
        return sisa ? `${rupiah}.${ribuan.join('.')}` : ribuan.join('.')
      }
      return (parseInt(angka, 10) || 0).toString()
    },
    resetForm() {
      this.fetchedTicket = null
      this.fetchedProduct = null
      this.resolvedCreatedBy = ''
      this.tanggalDibuat = this.getToday()
      this.photos = this.emptyPhotos()
      this.technicianFindings = ''
      this.damagedComponents = ''
      this.otherComponents = ''
      this.damageCategory = ''
      this.parts = [this.emptyPart()]
      this.notes = 'Harga dapat berubah sewaktu-waktu sesuai ketersediaan di pasaran.'
      this.errorMessage = ''
      this.attemptedSave = false
      this.attemptedSubmit = false
    },
    applyDarDetail(data) {
      this.fetchedTicket = data.ticket || null
      this.fetchedProduct = data.product || null
      // root-level createdAt is the DAR record's own timestamp - empty until it has
      // been saved as draft or submitted at least once, unlike ticket.createdDate
      // which always exists (that's the ticket's own creation date, not the DAR's)
      // const hasSavedDar = !!data.createdAt
      // this.tanggalDibuat = hasSavedDar ? data.ticket.createdDate.split(' ')[0] : this.getToday()
      this.tanggalDibuat = data.ticket.createdDate.split(' ')[0]
      this.resolvedCreatedBy =  data.ticket.createdBy
      this.photos = this.emptyPhotos()
      ;(data.photos || []).slice(0, 5).forEach((url, index) => {
        this.$set(this.photos, index, { imgFileName: '', imgBase64: '', imgUrl: url, isExisting: true })
      })
      this.technicianFindings = data.technicianFindings || ''
      this.damagedComponents = data.damagedComponents || ''
      this.otherComponents = data.otherComponents || ''
      this.damageCategory = data.damageCategory || ''
      this.parts = (data.parts || []).map(p => {
        const selectedPart = { itemCode: p.itemCode, itemName: p.partName }
        return {
          selectedPart,
          coveredBy: p.coveredBy || 'client',
          perkiraanHarga: String(p.estimatedPrice || 0),
          perkiraanHargaDisplay: this.formatRupiah(String(p.estimatedPrice || 0)),
          options: [selectedPart],
          searching: false,
        }
      })
      if (!this.parts.length) this.parts = [this.emptyPart()]
      this.notes = data.notes ? data.notes : 'Harga dapat berubah sewaktu-waktu sesuai ketersediaan di pasaran.'
      this.errorMessage = ''
      this.attemptedSave = false
      this.attemptedSubmit = false
    },
    applyOrResetDarDetail() {
      // darDetail is fetched once by the parent page load, not re-fetched on every open
      if (this.darDetail) {
        this.applyDarDetail(this.darDetail)
      } else {
        this.resetForm()
      }
      this.prefetchPartOptions()
    },
    prefetchPartOptions() {
      this.parts.forEach((part, index) => {
        if (!part.options.length && !part.searching) {
          this.fetchPartOptions('', index)
        }
      })
    },
    onPartDropdownOpen(index) {
      if (!this.parts[index].options.length && !this.parts[index].searching) {
        this.fetchPartOptions('', index)
      }
    },
    onPartSearch(query, index) {
      clearTimeout(this.partSearchTimers[index])
      this.partSearchTimers[index] = setTimeout(() => {
        this.fetchPartOptions(query, index)
      }, 500)
    },
    onAddCustomPart(query, index) {
      const customPart = { itemCode: 0, itemName: query }
      this.parts[index].options.push(customPart)
      this.parts[index].selectedPart = customPart
      const refName = `partSelect${index}`
      if (this.$refs[refName] && this.$refs[refName][0]) {
        this.$refs[refName][0].deactivate()
      }
    },
    fetchPartOptions(query, index) {
      this.$set(this.parts[index], 'searching', true)
      this.$http.post(process.env.GET_DAR_PART_LIST, {
        partName: query || '',
        page: 1,
        itemPerPage: 30,
      }, {
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(response => {
        this.$set(this.parts[index], 'searching', false)
        if (response.data.status === 200) {
          this.$set(this.parts[index], 'options', (response.data.data || []).map(item => ({
            itemCode: item.itemCode,
            itemName: item.itemName,
          })))
        }
      })
      .catch(error => {
        this.$set(this.parts[index], 'searching', false)
        if (error.response && error.response.data && error.response.data.status === 401) {
          this.$emit('onUnauthorized')
        }
      })
    },
    buildPayload(isDraft) {
      return {
        ticketId: Number(this.ticketId),
        photos: this.photos.filter(p => p.imgUrl).map(p => (p.isExisting ? p.imgUrl : p.imgBase64)),
        technicianFindings: this.technicianFindings,
        damagedComponents: this.damagedComponents,
        otherComponents: this.otherComponents,
        damageCategory: this.damageCategory,
        parts: this.parts.map(p => ({
          itemCode: p.selectedPart ? Number(p.selectedPart.itemCode) : 0,
          partName: p.selectedPart ? p.selectedPart.itemName : '',
          coveredBy: p.coveredBy,
          estimatedPrice: parseInt(p.perkiraanHarga, 10) || 0,
        })),
        notes: this.notes,
        asDraft: isDraft ? 1 : 0,
      }
    },
    saveDar(isDraft) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.errorMessage = ''

      if (this.parts.some(p => !p.selectedPart)) {
        this.attemptedSave = true
        swalWithBootstrapButtons.fire({
          title: "Sorry",
          text: "Nama Part wajib diisi untuk semua part sebelum menyimpan.",
          icon: "error",
        })
        return
      }

      if (!isDraft && !this.canSubmit) {
        this.attemptedSubmit = true
        swalWithBootstrapButtons.fire({
          title: "Sorry",
          text: "Lengkapi semua field wajib sebelum submit dokumen.",
          icon: "error",
        })
        return
      }
      const loadingKey = !isDraft ? 'loadingSubmit' : 'loadingDraft'
      this[loadingKey] = true
      this.$http.post(process.env.SAVE_DAR_DATA, this.buildPayload(isDraft), {
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(response => {
        this[loadingKey] = false
        if (response.data.status !== 200) {
          this.errorMessage = response.data.message
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: response.data.message,
            icon: "error",
          })
          return
        }
        this.$emit(!isDraft ? 'submit' : 'save-draft', response.data.data)
      })
      .catch(error => {
        this[loadingKey] = false
        this.errorMessage = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message
        swalWithBootstrapButtons.fire({
          title: "Sorry",
          text: this.errorMessage,
          icon: "error",
        }).then(() => {
          if (error.response && error.response.data && error.response.data.status === 401) {
            this.$emit('onUnauthorized')
          }
        })
      })
    },
    saveDraft() {
      this.saveDar(true)
    },
    submitDocument() {
      this.saveDar(false)
    },
  },
  watch: {
    darDetail: {
      immediate: true,
      handler() {
        this.applyOrResetDarDetail()
      },
    },
  },
  created() {
    this.cekPermission()
  },
  mounted() {
    $('#modalFormDar').on('show.bs.modal', this.applyOrResetDarDetail)
  },
  beforeDestroy() {
    $('#modalFormDar').off('show.bs.modal', this.applyOrResetDarDetail)
    Object.values(this.partSearchTimers).forEach(timer => clearTimeout(timer))
  },
}
</script>

<style scoped>
.modal-subtitle {
  font-size: 13px;
  color: #6C757D;
  margin-top: 4px;
  font-weight: normal;
}

.section-card {
  background-color: #F8F9FB;
  border: 1px solid #E5E8EC;
  border-radius: 8px;
  padding: 16px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #2E3646;
}

.field-label {
  font-size: 13px;
  font-weight: 500;
  color: #2E3646;
  margin-bottom: 6px;
}

.is-invalid-box {
  border: 1px solid #dc3545;
  border-radius: 6px;
  padding: 10px 12px;
}

.multiselect-invalid >>> .multiselect__tags {
  border-color: #dc3545;
}

.field-hint {
  font-size: 11px;
  color: #8A94A6;
  margin-top: 4px;
}

.readonly-field {
  background-color: #EFF1F4 !important;
  color: #2E3646;
  cursor: not-allowed;
}

.specification-field {
  resize: none;
}

.bom-items-box {
  min-height: 38px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 6px 12px;
  font-size: 14px;
}

.photo-counter {
  font-size: 12px;
  color: #8A94A6;
}

.photo-upload-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.photo-slot {
  position: relative;
  border: 1px dashed #cfd3d9;
  background-color: #FFFFFF;
  border-radius: 8px;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8A94A6;
  overflow: hidden;
}

.photo-slot:hover {
  border-color: #2797FB;
  color: #2797FB;
}

.photo-slot.has-image {
  border-style: solid;
  padding: 0;
}

.photo-slot-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.photo-slot i {
  font-size: 18px;
  margin-bottom: 4px;
}

.photo-slot-label {
  font-size: 11px;
}

.photo-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  line-height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 14px;
}

.radio-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: normal;
  margin-bottom: 0;
  cursor: pointer;
}

.part-card {
  border: 1px solid #E5E8EC;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 16px;
}

.part-not-found-text {
  padding: 10px 12px;
  font-size: 13px;
  color: #8A94A6;
}

.btn-add-custom-part {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 12px 8px;
  padding: 8px 12px;
  border: 1px solid #2797FB;
  border-radius: 6px;
  background-color: #FFFFFF;
  color: #2797FB;
  font-size: 13px;
  text-align: left;
}

.btn-add-custom-part:hover {
  background-color: #F1F7FE;
}

.part-title {
  font-size: 14px;
  font-weight: 600;
  color: #2E3646;
}

.btn-remove-part {
  border: none;
  background: none;
  color: #FF5D5D;
  padding: 0;
}

.total-box {
  background-color: #F1F3F6;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #2E3646;
}

.total-box-highlight {
  background-color: #E8F0FE;
}
</style>



// WEBPACK FOOTER //
// src/components/Resolution/CustomComponent/DAR/ModalFormDar.vue